import './instagram_message_base_parser.js.coffee'
Namespace 'Models.Parsers'

class Models.Parsers.InstagramMessageTextParser extends Models.Parsers.InstagramMessageBaseParser
  canHandle: (messageJSON) ->
    ['text', 'inline_reply'].includes(messageJSON.message_type)

  parse: (messageJSON) ->
    builder = new Models.Builders.InstagramMessageTextBuilder
    @_doParse(builder, messageJSON)
    builder.messageText = @_getMessage(messageJSON).text
    builder.build()
